
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bumble-hq",
      function () {
        return require("private-next-pages/bumble-hq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bumble-hq"])
      });
    }
  